import { render, staticRenderFns } from "./crudCourses.vue?vue&type=template&id=2dffdca4&"
import script from "./crudCourses.vue?vue&type=script&lang=js&"
export * from "./crudCourses.vue?vue&type=script&lang=js&"
import style0 from "./crudCourses.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports